import { Injectable } from "@angular/core";
import { Tradable } from "@models/interfaces/tradable";
import { Observable, switchMap } from "rxjs";
import { filter, map } from "rxjs/operators";
import { FOLLOWING_WIDGET_MAX_ITEMS } from "@helpers/constants";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { WatchlistFacade } from "@modules/watchlist/domain/+state/watchlist.facade";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TradableChartService } from "@main-services/tradable-chart.service";
import { Timespan } from "@helpers/const/timespan";

export interface WatchlistWidgetViewModel {
	list: Tradable[];
	readonly totalLength: number;
}

@UntilDestroy()
@Injectable()
export class WatchlistWidgetFacade {
	constructor(
		private readonly watchlistFacade: WatchlistFacade,
		private tradableListService: TradableListService,
		private readonly tradableChartService: TradableChartService
	) {}

	public getViewModel$(): Observable<WatchlistWidgetViewModel> {
		return this.watchlistFacade.getWatchlistState$().pipe(
			filter((watchlistModel) => !!watchlistModel && !watchlistModel.isError),
			switchMap((watchlistModel) => {
				return this.watchlistFacade.addBffAssetsToWatchlistHelper$(watchlistModel);
			}),
			map((watchlistModel) => ({
				list: watchlistModel.tradableIds
					.slice(0, FOLLOWING_WIDGET_MAX_ITEMS)
					.map((id: string) => this.tradableListService.getItemById(id)),
				totalLength: watchlistModel.tradableIds.length
			}))
		);
	}

	public initChartUpdates(): void {
		this.watchlistFacade
			.getWatchlistState$()
			.pipe(
				untilDestroyed(this),
				switchMap((watchlistModel) => this.watchlistFacade.addBffAssetsToWatchlistHelper$(watchlistModel))
			)
			.subscribe((state) => {
				if (state.tradableIds.length > 0) {
					const tradables = state.tradableIds
						.slice(0, FOLLOWING_WIDGET_MAX_ITEMS)
						.map((id) => this.tradableListService.getItemById(id));
					this.tradableChartService.updateMultiple(tradables, Timespan.Day, true);
				}
			});
	}
}
